var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey lighten-3 mb-5"},[_c('v-breadcrumbs',{staticClass:"pl-0 py-8 justify-center",attrs:{"items":_vm.items},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{staticClass:"title",attrs:{"to":{ name: item.link },"disabled":item.disabled,"exact":""}},[_vm._v(" "+_vm._s(item.text.toUpperCase())+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }